import { render } from "./Wrapper.vue?vue&type=template&id=50b929f3&scoped=true"
import script from "./Wrapper.vue?vue&type=script&lang=js"
export * from "./Wrapper.vue?vue&type=script&lang=js"

import "./Wrapper.vue?vue&type=style&index=0&id=50b929f3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b929f3"]])

export default __exports__